import { useEffect, useState } from 'react';
import './BuildInfo.css';

interface BuildInfoData {
  gitHash: string;
  gitHashFull: string;
  gitBranch: string;
  commitDate: string;
  buildTimestamp: string;
  isDirty: boolean;
  version: string;
}

export default function BuildInfo() {
  const [buildInfo, setBuildInfo] = useState<BuildInfoData | null>(null);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    // Try to load build info from public directory first (runtime)
    fetch('/build-info.json')
      .then(response => response.json())
      .then(data => setBuildInfo(data))
      .catch(async () => {
        // Fallback to compile-time build info
        try {
          const buildData = await import('../build-info.json');
          setBuildInfo(buildData.default || buildData);
        } catch (error) {
          console.warn('Build info not available');
        }
      });
  }, []);

  if (!buildInfo) {
    return null;
  }

  const formatDate = (isoString: string) => {
    try {
      return new Date(isoString).toLocaleString();
    } catch {
      return isoString;
    }
  };

  const handleClick = () => {
    setShowDetails(!showDetails);
  };

  return (
    <div className="build-info">
      <div className="build-info-summary" onClick={handleClick} title="Click for build details">
        <span className="build-hash">
          {buildInfo.gitHash}
          {buildInfo.isDirty && <span className="dirty-indicator">*</span>}
        </span>
        <span className="build-version">v{buildInfo.version}</span>
      </div>
      
      {showDetails && (
        <div className="build-info-details">
          <div className="build-detail">
            <span className="detail-label">Commit:</span>
            <span className="detail-value">{buildInfo.gitHashFull}</span>
          </div>
          <div className="build-detail">
            <span className="detail-label">Built Date:</span>
            <span className="detail-value">{formatDate(buildInfo.buildTimestamp)}</span>
          </div>
        </div>
      )}
    </div>
  );
}